import { Directive, EventEmitter, Output, OnInit, ElementRef, NgZone } from '@angular/core';

declare global {
  interface Window {
    grecaptcha: any;
    grecaptchaLoaded: () => void;
  }
}

@Directive({
  selector: '[appRecaptcha]'
})

export class RecaptchaDirective implements OnInit {
  private readonly element: HTMLElement;

  constructor(el: ElementRef, private zone: NgZone) {
    // private environment: EnvironmentService,
    this.element = el.nativeElement;
  }

  @Output() verified: EventEmitter<any> = new EventEmitter<any>();
  @Output() expired: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit() {
    // Set up the callback.
    window.grecaptchaLoaded = () => {
      console.log('ReCaptcha loaded!');
      this.renderWidget();
    };

    this.renderScriptTag();
    console.log('ReCaptcha initializing!');
  }

  challengeUser(): void {
    window.grecaptcha.execute();
  }

  private renderScriptTag() {
    const scriptTag = document.createElement('script');
    scriptTag.id = 'recaptcha';
    scriptTag.src = 'https://www.recaptcha.net/recaptcha/api.js?onload=grecaptchaLoaded&render=explicit&hl=nl';
    scriptTag.async = true;
    scriptTag.defer = true;
    this.element.insertAdjacentElement('afterend', scriptTag);
  }

  private renderWidget() {
    window.grecaptcha.render(this.element, {
      'sitekey': '6LcUoXAUAAAAABLt5ZT64RXuU6tnGNjDja7UwZ5a',
      'callback': (data) => {
        this.zone.run(() => {
          if (data) {
            this.verified.emit(data);
          }
        });
      },
      'expired-callback': () => {
        this.zone.run(() => {
          this.expired.emit();
        });
      },
      'error-callback': (data) => {
        this.zone.run(() => {
          console.log('error');
          console.log(data);
        });
      },
      'theme': 'light',
      'size': 'invisible'
    });
    console.log('ReCaptcha ready!');
  }
}
